import Attachment from './Attachment';
import AuthBoxLayout from './AuthBoxLayout';
import NameCard from './nameCard/NameCard';
import Button from './Button';
import Label from './Label';
import Icon from './Icon';
import BreadCrumb from './breadcrumb/BreadCrumb';
import BreadCrumbItem from './breadcrumb/BreadCrumbItem';
import Spinner from './Spinner';
import Tip from './Tip';
import Chip from './Chip';
import LoadMore from './LoadMore';
import Pagination from './pagination/Pagination';
import ReportPagination from './reportPagination/ReportPagination';
import ModalTrigger from './ModalTrigger';
import ModalTriggerUI from './ModalTriggerUI';
import ActionButtons from './ActionButtons';
import EmptyState from './EmptyState';
import Bulk from './Bulk';
import Filter from './filter/Filter';
import Tags from './Tags';
import FilterableList from './filterableList/FilterableList';
import DropdownToggle from './DropdownToggle';
import ImportFile from './ImportFile';
import ChooserSelector from './ChooserSelector';
import MenuListing from './MenuListing';
import LabelInputWithIcon from './LabelInputWithIcon';
import { DialScreenTheme } from '../../..';
import {
  FormControl,
  ControlLabel,
  FormGroup,
  Textarea,
  SelectWithSearch,
} from './form';
import CommonPermission from './CommonPermission';
import { Step, Steps, ConditionStep } from './step';
import TextDivider from './TextDivider';
import CountsByTag from './CountsByTag';
import FilterByParams from './FilterByParams';
import Table from './table';
import Editor from './editor/Editor';
import { Tabs,
  // TabList,
   TabTitle } from './tabs';
import ConfirmDialog from './ConfirmDialog';
import DataWithLoader from './DataWithLoader';
import SortableList from './SortableList';
import SortableListWithTwoInputs from './SortableListWithTwoInputs';
import ImageWithPreview from './ImageWithPreview';
import IntegrationIcon from './IntegrationIcon';
import Chooser from './Chooser';
import DateFilter from './DateFilter';
import PhoneFilter from './PhoneFilter';
import ModifiableSelect from './ModifiableSelect';
import SortHandler from './SortHandler';
import ProjectFilter from './ProjectFilter';
import AudioPlayer from './AudioPlayer';
import SettingTheme from './SettingTheme';
import DashboardTheme from './DashboardTheme';
import DashboardTileTheme from './DashboardTileTheme';
import HeaderDialpad from './HeaderDialpad';
import OfflineDialpad from './OfflineDialpad';
import CallHandlerTheme from './CallHandlerTheme';
import BardgeButton from './BardgeButton';
import PreviewButton from './PreviewButton';
import CallInboundTheme from './CallInboundTheme';
import CallBackNotifyTheme from './CallBackNotifyTheme';
import CallbackScreenTheme from './CallbackScreenTheme';
import DTMFTheme from './DTMFTheme';
import CallTagTheme from './CallTagTheme';
import CallInfoTheme from './CallInfoTheme';
import AddCallTheme from './AddCallTheme';
import AddNewCallTheme from './AddNewCallTheme';
import FAQTheme from './FAQTheme';
import ChatListTheme from './ChatListTheme';
import MessageListTheme from './MessageListTheme';
import OnlineScreenTheme from './OnlineScreenTheme';
import EndCallProfileTheme from './EndCallProfileTheme';
import LiveMonitorTheme from './LiveMonitorTheme';
import LiveMonitorTheme2 from './LiveMonitorTheme2';
import DynamicAgTable from './DynamicAgTable';
import ManageColumns from './ManageColumns';
import EndCallAgentProfileTheme from './EndCallAgentProfileTheme';
import EndCallChangePwdTheme from './EndCallChangePwdTheme';
import CallBreakTheme from './CallBreakTheme';
import CallBreakSelectTheme from './CallBreakSelectTheme';
import CallDashboardTheme from './CallDashboardTheme';
import ContactInfoNoteTheme from './ContactInfoNoteTheme';
import ContactInfoSmartAgent from './ContactInfoSmartAgent'
import ContactProfileTheme from './ContactProfileTheme';
import ContactInfoActivityTheme from './ContactInfoActivityTheme';
import AgentDashboardTheme from './AgentDashboardTheme';
import ContactInfoActivityTimelineTheme from './ContactInfoActivityTimelineTheme';
import CallPreviewLoading from './CallPreviewLoading';
import SelectFilterAPI from './SelectFilterAPI';
import Accordion from './Accordion';
import NotificationTheme from './NotificationTheme';
import CallFooterTheme from './CallFooterTheme';
import ReportFilterHeaderTheme from './ReportFilterHeaderTheme';
import CommonFilter from './CommonFilter';
import ButtonCommonTheme from './ButtonCommonTheme';
import SettingDropdownMenu from './SettingDropdownMenu';
import PhonenumberModalHeader from './PhonenumberModalHeader';
import ReportingTheme from './ReportingTheme';
import ReportingDropdownMenu from './ReportingDropdownMenu';
import ContactLeftPartTheme from './ContactLeftPartTheme';
import ContactRightPartTheme from './ContactRightPartTheme';
import ContactBodyTheme from './ContactBodyTheme';

export {
  Accordion,
  DialScreenTheme,
  AuthBoxLayout,
  Attachment,
  ActionButtons,
  NameCard,
  Button,
  Label,
  LabelInputWithIcon,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  LoadMore,
  Chip,
  CommonPermission,
  Pagination,
  ProjectFilter,
  ReportPagination,
  ModalTrigger,
  ModalTriggerUI,
  EmptyState,
  Bulk,
  CountsByTag,
  Filter,
  FilterByParams,
  Tags,
  FilterableList,
  DropdownToggle,
  FormControl,
  Textarea,
  ControlLabel,
  FormGroup,
  Step,
  Steps,
  ConditionStep,
  TextDivider,
  Table,
  Editor,
  Tabs,
  // TabList,
  PhoneFilter,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  SortableListWithTwoInputs,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  ModifiableSelect,
  SortHandler,
  SelectWithSearch,
  ChooserSelector,
  AudioPlayer,
  ImportFile,
  SettingTheme,
  DashboardTheme,
  DashboardTileTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  PreviewButton,
  BardgeButton,
  CallInboundTheme,
  CallBackNotifyTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  EndCallProfileTheme,
  LiveMonitorTheme,
  LiveMonitorTheme2,
  DynamicAgTable,
  ManageColumns,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoNoteTheme,
  ContactInfoSmartAgent,
  ContactInfoActivityTheme,
  AgentDashboardTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
  SelectFilterAPI,
  NotificationTheme,
  CallbackScreenTheme,
  CallFooterTheme,
  ReportFilterHeaderTheme,
  CommonFilter,
  ButtonCommonTheme,
  SettingDropdownMenu,
  PhonenumberModalHeader,
  ReportingTheme,
  ReportingDropdownMenu,
  ContactLeftPartTheme,
  ContactRightPartTheme,
  ContactBodyTheme,
  MenuListing,
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/index.js